import * as Types from './types';
import { Dispatch } from 'redux';
import {
  IAction,
  IActionMethods,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as MessageOutgoingService from '../../../services/api/message_outgoing';
import * as RequestInformation from '../../../services/api/info_request';

interface IFetchMessageOutgoingListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  destinationCountry?: string;
  messageType?: string;
  status?: string;
}

class FetchMessageOutgoingList implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MESSAGE_OUTGOING_LIST,
      status: StateStatus.Pending,
      data: KEEP_THE_SAME,
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MESSAGE_OUTGOING_LIST,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MESSAGE_OUTGOING_LIST,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IFetchMessageOutgoingListInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await MessageOutgoingService.fetchMessageOutgoing(
          payload
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMessageOutgoingList Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

class FetchMemberStateExcludeCyprus implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.SET_MEMBER_STATE_EXCLUDE_CYPRUS,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await RequestInformation.getCountriesMemberState(true);
        // console.log(response.data);
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMemberStateExcludeCyprus Error:', error.message);
        dispatch(this.onFailed());
      }
    };
  }
}

interface IFetchMessageOutgoingXmlInput {
  messageId: string;
}

class FetchMessageOutgoingXml implements IActionMethods {
  onPending(): IAction {
    return {
      type: Types.GET_MESSAGE_OUTGOING_XML,
      status: StateStatus.Pending,
      data: {},
    };
  }
  onSuccess(data: any): IAction {
    return {
      type: Types.GET_MESSAGE_OUTGOING_XML,
      status: StateStatus.Success,
      data: data,
    };
  }

  onFailed(): IAction {
    return {
      type: Types.GET_MESSAGE_OUTGOING_XML,
      status: StateStatus.Failed,
      data: {},
    };
  }

  action(payload: IFetchMessageOutgoingXmlInput): any {
    return async (dispatch: Dispatch<any>) => {
      try {
        dispatch(this.onPending());
        let response = await MessageOutgoingService.fetchMessageOutgoingXml(
          payload
        );
        dispatch(this.onSuccess(response.data));
      } catch (error: any) {
        // console.log('FetchMessageOutgoingXml Error:', error.message); // '<ClassName> Error: <error>'
        dispatch(this.onFailed());
      }
    };
  }
}

export default {
  fetchMessageOutgoingAction: (payload: IFetchMessageOutgoingListInput) =>
    new FetchMessageOutgoingList().action(payload),
  fetchMemberStateExcludeCyprusAction: () =>
    new FetchMemberStateExcludeCyprus().action(),
  fetchMessageOutgoingXmlAction: (payload: IFetchMessageOutgoingXmlInput) =>
    new FetchMessageOutgoingXml().action(payload),
};
